import { render, staticRenderFns } from "./CrawlpagesFromTags.vue?vue&type=template&id=531cff5a&"
import script from "./CrawlpagesFromTags.vue?vue&type=script&lang=js&"
export * from "./CrawlpagesFromTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports